import { createSelector, createFeatureSelector } from "@ngrx/store";
import { Pinsheet } from "../models/pinsheet.model";

export const pinsheet = createFeatureSelector<Pinsheet>('pinsheet')
export const greenThumbnail = createFeatureSelector<any>('greenThumbnail')
export const pinsheetDate = createFeatureSelector<any>('pinsheetDate')
export const greenSpeed = createFeatureSelector<any>('greenSpeed')
export const daysOfHistory = createFeatureSelector<any>('daysOfHistory')
export const pinsheetUpdate = createFeatureSelector<any>('pinsheetUpdate')
export const thumbnailClick = createFeatureSelector<any>('thumbnailClick')
export const colorIndication = createFeatureSelector<any>('colorIndication')
export const greenAngle = createFeatureSelector<any>('greenAngle')
export const showTeeBox = createFeatureSelector<any>('showTeeBox')

export const selectPinsheetCollection = createSelector(
    pinsheet,
    (pinsheet) => pinsheet
)
export const selectGreenThumbnailCollection = createSelector(
    greenThumbnail,
    (greenThumbnail) => greenThumbnail
)
export const selectPinsheetDateCollection = createSelector(
    pinsheetDate,
    (pinsheetDate) => pinsheetDate
)
export const selectGreenSpeedCollection = createSelector(
    greenSpeed,
    (greenSpeed) => greenSpeed
)
export const selectDaysOfHistoryCollection = createSelector(
    daysOfHistory,
    (daysOfHistory) => daysOfHistory
)
export const selectPinsheetUpdateCollection = createSelector(
    pinsheetUpdate,
    (pinsheetUpdate) => pinsheetUpdate
)
export const selectthumbnailClickCollection = createSelector(
    thumbnailClick,
    (thumbnailClick) => thumbnailClick
)
export const selectColorIndication = createSelector(
    colorIndication,
    (colorIndication) => colorIndication
)
export const selectGreensAngleCollection = createSelector(
    greenAngle,
    (greenAngle) => greenAngle
)
export const selectShowTeeBoxes = createSelector(
    showTeeBox,
    (showTeeBox) => showTeeBox
)